import { render, staticRenderFns } from "./ListWallet.vue?vue&type=template&id=8bb647a0&"
import script from "./ListWallet.vue?vue&type=script&lang=js&"
export * from "./ListWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports